import React, { useEffect } from 'react';
import { Schema } from '../../../../../lib/common/custom-activity/eventTypes';
import {
    done,
    cancel,
    statusCodeChanged,
    updateStateFromActivity,
    DataSelectorState,
} from './dataSelectorSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { DockedFooter } from '../../../../../lib/client/components/dockedFooter';

export function DataSelector() {
    const activity = useAppSelector((state) => state.journey.activity);
    const schema = useAppSelector((state) => state.journey.schema);

    const dataSelectorState = useAppSelector((state) => state.dataSelector);

    const statusCode = useAppSelector((state) => state.dataSelector.statusCode);
    const dispatch = useAppDispatch();

    useEffect(() => {
        // If activity changes, we need to load our selection state from it.
        if (activity !== null) {
            dispatch(updateStateFromActivity(activity));
        }
    }, [activity]);

    if (activity === null || schema === null) {
        return (
            <div>Waiting for Journey Builder to initialize the activity.</div>
        );
    }

    const schemaSelectOptions: JSX.Element[] = getJourneySchemaOptions(schema);

    return (
        <div>
            <div className="selectionContainer">
                <div>Return this status code:</div>
                <input
                    className="slds-select"
                    defaultValue={statusCode ?? ''}
                    onChange={(event) =>
                        dispatch(statusCodeChanged(event.target.value))
                    }
                />
            </div>
            <DockedFooter
                canSubmit={() => canSubmit(dataSelectorState)}
                cancel={() => dispatch(cancel())}
                done={() => dispatch(done(activity))}
            />
        </div>
    );
}

function canSubmit(state: DataSelectorState) {
    // return (
    //     state.dirty &&
    //     state.statusCode !== null
    // )
    return true;
}

function RequiresComparisonText(comparisonType: string) {
    return comparisonType === 'Equals';
}

function getJourneySchemaOptions(schema: Schema): JSX.Element[] {
    const options: JSX.Element[] = [];
    for (let object of schema) {
        options.push(
            <option key={object.key} value={object.key}>
                {object.name}
            </option>,
        );
    }
    return options;
}
